import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class ParticipantStore {
  @observable participants = [];
  @observable eligibility_search = []
  @observable Physician_Drug_Cost_TimeLine = []
  @observable load_date = ""
  @observable single_participant = {};
  @observable male_count = 0;
  @observable female_count = 0;
  @observable participant_count = 0;
  @observable count = 0;
  @observable average_age = 0;
  @observable employees_count = 0;
  @observable dependents_count = 0;
  @observable url = "/api/v1/dataactions/participants";
  @observable filterValue = "";
  @observable spendRange = [
    {
      "0-20": "0",
      "20-100": "0",
      "100-750": "0",
      "750+": "0"
    }
  ];
  @observable participantInfo = [
    {
      name: "",
      age: "",
      TOTAL_CLAIMS: "",
      sex: "",
      TOTAL_COST: "",
      co_pay: "",
      plan_pay: ""
    }
  ];
  @observable drugs = [];
  @observable monthSpend = []

  @computed get tiles() {
    return parseInt(this.count / 100) > 0 ? parseInt(this.count / 100) + 1 : 0;
  }


  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.participants.length > 0) {

      if (filter == "life_id") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.life_id) > parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) < parseInt(b.life_id)) return 1;
          return 0
        })
      }
      if (filter == "type") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.is_primary > b.is_primary) return -1;
          if (a.is_primary < b.is_primary) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.TOTAL_COST) > parseInt(b.TOTAL_COST)) return -1;
          if (parseInt(a.TOTAL_COST) < parseInt(b.TOTAL_COST)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "claims_count") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return 1;
          return 0
        })
      }

      if (filter == "sex") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.sex > b.sex) return -1;
          if (a.sex < b.sex) return 1;
          return 0
        })
      }

      if (filter == "age") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.age > b.age) return -1;
          if (a.age < b.age) return 1;
          return 0
        })
      }
      if (filter == "plan_type") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.plan_type > b.plan_type) return -1;
          if (a.plan_type < b.plan_type) return 1;
          return 0
        })
      }

    }
  }

  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.participants.length > 0) {

      if (filter == "life_id") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.life_id) < parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) > parseInt(b.life_id)) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.TOTAL_COST) < parseInt(b.TOTAL_COST)) return -1;
          if (parseInt(a.TOTAL_COST) > parseInt(b.TOTAL_COST)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "claims_count") {
        this.participants = this.participants.sort(function (a, b) {
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return 1;
          return 0
        })
      }

      if (filter == "sex") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.sex < b.sex) return -1;
          if (a.sex > b.sex) return 1;
          return 0
        })
      }

      if (filter == "age") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.age < b.age) return -1;
          if (a.age > b.age) return 1;
          return 0
        })
      }
      if (filter == "plan_type") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.plan_type < b.plan_type) return -1;
          if (a.plan_type > b.plan_type) return 1;
          return 0
        })
      }
      if (filter == "type") {
        this.participants = this.participants.sort(function (a, b) {
          if (a.is_primary < b.is_primary) return -1;
          if (a.is_primary > b.is_primary) return 1;
          return 0
        })
      }

    }
  }

  @action getPhysicianDrugCostTimeLine = async data => {
    this.Physician_Drug_Cost_TimeLine = [];
    try {
      let response = await post(
        `${this.url}/getPhysicianDrugCostTimeLine`,
        data
      );

      this.Physician_Drug_Cost_TimeLine = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getParticipants = async data => {
    this.partiticpants = [];
    try {
      let response = await post(
        `${this.url}/getParticipants`,
        data
      );

      this.participants = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getSingleParticipant = async data => {
    this.single_participant = {};
    try {
      let response = await post(
        `${this.url}/getSingleParticipant`,
        data
      );

      this.single_participant = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getSpendRange = async data => {
    this.drugs = [];
    try {
      let response = await post(
        `${this.url}/getSpendRange`,
        data
      );

      this.spendRange = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getParticipantInfo = async data => {
    this.participantInfo = [
      {
        name: "",
        age: "",
        TOTAL_CLAIMS: "",
        sex: "",
        TOTAL_COST: "",
        co_pay: "",
        plan_pay: ""
      }
    ];

    try {
      let response = await post(
        `${this.url}/getParticipantInfo`,
        data
      );

      this.participantInfo = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDrugs = async data => {
    try {
      let response = await post(
        `${this.url}/getDrugs`,
        data
      );

      this.drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getMonthSpends = async data => {
    try {
      let response = await post(
        `${this.url}/getMonthSpends`,
        data
      );

      this.monthSpend = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDrugCostTimeLine = async data => {
    this.monthSpend = [];
    try {
      let response = await post(
        `${this.url}/getDrugCostTimeLine`,
        data
      );

      this.monthSpend = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getEmployeeStats = async data => {
    this.employees_count = 0;
    this.dependents_count = 0
    try {
      let response = await post(
        `${this.url}/getEmployeeStats`,
        data
      );

      this.employees_count = response.data[0].employee_count;
      this.dependents_count = response.data[0].life_count;
    } catch (err) {
      console.log(err);
    }
  };

  @action getAverageAge = async data => {
    this.average_age = 0;
    try {
      let response = await post(
        `${this.url}/getAverageAge`,
        data
      );

      this.average_age = response.data[0].avg_age;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalCount = async data => {
    this.participant_count = 0;
    try {
      let response = await post(
        `${this.url}/getTotalCount`,
        data
      );

      this.participant_count = response.data[0].participant_count;
    } catch (err) {
      console.log(err);
    }
  };

  @action getCount = async data => {
    this.count = 0;
    try {
      let response = await post(
        `${this.url}/getCount`,
        data
      );

      this.count = response.data[0].count;
    } catch (err) {
      console.log(err);
    }
  };


  @action getMaleCount = async data => {
    this.male_count = 0;
    try {
      let response = await post(
        `${this.url}/getMaleCount`,
        data
      );

      this.male_count = response.data[0].male_count;
    } catch (err) {
      console.log(err);
    }
  };

  @action get_eligibility_status = async data => {
    this.eligibility_search = []
    this.load_date = ""
    try {
      let response = await post(
        `${this.url}/get_eligibility_status`,
        data
      );
      this.eligibility_search = response.data.life_data;
      this.load_date = response.data.last_file_loaded_date
    } catch (err) {
      console.log(err);
    }
  }

  @action getFemaleCount = async data => {
    this.female_count = 0;
    try {
      let response = await post(
        `${this.url}/getFemaleCount`,
        data
      );
      this.female_count = response.data[0].female_count;
    } catch (err) {
      console.log(err);
    }
  };
}

export default ParticipantStore;
